import { useContext } from 'react';
import { AuthContext } from '../components/contexts/AuthContext';

export function useAuth() {
  const {
    state,
    login,
    logout,
    getIdToken,
    reloadCurrentUser,
  } = useContext(AuthContext);
  return { state, login, logout, getIdToken, reloadCurrentUser };
}
